import { Literals } from "shared/types";
import classNames from "shared/utils/classNames";

type Props = {
  onBackClick: () => void;
  className?: string;
  copyTexts: Literals;
  isIframe?: boolean;
};

function BackButton(props: Props) {
  const { onBackClick, className, copyTexts, isIframe } = props;

  return (
    <button
      className={classNames(
        "group border-none bg-transparent",
        isIframe ? "text-black" : "text-[var(--invertedColor)]",
        className,
      )}
      onClick={onBackClick}
    >
      <i
        className={classNames(
          "ti ti-arrow-left text-2xl leading-6",
          isIframe ? "stroke-black" : "text-[var(--invertedColor)]",
        )}
      />
      <p className="absolute left-4 hidden max-w-min whitespace-nowrap rounded-lg bg-black px-2 py-1 text-white opacity-80 group-hover:block">
        {copyTexts.goBackButtonText}
      </p>
    </button>
  );
}

export default BackButton;
